<template >
    <b-col md="12" ref="document" sm="8" >
        <b-card no-body  class="mx-4">
            <b-card-header header-bg-variant="primary" header-text-variant="white">
                <h1 class="titulo"><span class="bold">Formulário {{questionario.titulo}}</span></h1>
            </b-card-header>
            <b-card-body  class="p-4">
                <b-form v-on:submit.prevent="onSubmit">
                    <b-row>
                        <b-col class="col-md-9 col-sm-12">
                            <span v-if="!visualizar" class="text-danger"><span class="bold">*</span> Preenchimento Obrigatório</span>
                        </b-col>                    
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col class="col-md-8 col-sm-12">
                            <b-form-group>
                                <template slot="label">Responsavél pelo preenchimento <span class="bold text-danger">*</span></template>
                                <b-input-group class="mb-3">
                                    <b-form-input                                                                     
                                        type="text"
                                        class="form-control"
                                        placeholder="" />
                                    <b-form-invalid-feedback id="input1LiveFeedback3">Responsável pelo preenchimento é um campo obrigatório.</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-md-8 col-sm-12">
                            <b-form-group>
                                <template slot="label">Nome da Organização <span class="bold text-danger">*</span></template>
                                <b-input-group class="mb-3">
                                    <b-form-input
                                        type="text"
                                        class="form-control"
                                        placeholder="" />
                                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome da Organização é um campo obrigatório.</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-md-6 col-sm-12">
                            <b-form-group>
                                <template slot="label">CPF do Responsavél pelo preenchimento <span class="bold text-danger">*</span></template>
                                <b-input-group class="mb-3">
                                    <b-form-input                                                             
                                        type="text"
                                        v-mask="'###.###.###-##'"
                                        class="form-control"
                                        placeholder="" />                         
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-md-6 col-sm-12">
                            <b-form-group>
                                <template slot="label">E-mail do Responsavél pelo preenchimento <span class="bold text-danger">*</span></template>
                                <b-input-group class="mb-3">
                                    <b-form-input                                                                    
                                        type="text"                                  
                                        class="form-control"
                                        placeholder="" />                            
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row> 
                    <b-row>
                        <b-col class="col-md-12 col-sm-12">
                            <b-form-group>
                                <b-form-checkbox
                                    id="localizacao"                              
                                    name="localizacao"
                                    value="aceito"
                                    unchecked-value="nao_aceito"
                                >
                                    <span >Aceito informar a localização de onde estou preenchendo o formulário.</span>
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>         
                    <br>
                    <b-row v-if="questionario.descricao">
                        <b-col class="col-md-12 col-sm-12">
                        <b-col class="card-header-form titulo secao-head">
                            <label>Descrição</label>
                        </b-col>
                        <b-card-body>
                            <span v-html="questionario.descricao" style="font-size: 14px"/>
                        </b-card-body>
                        </b-col>
                    </b-row>
                    <b-row v-for="(linha, i) in secoesQuestionario" :key="i">
                        <b-col class="col-md-12 col-sm-12">
                            <b-col class="card-header-form titulo secao-head">
                                <label>{{linha.titulo}}</label>
                            </b-col>
                            <b-card-body>
                                <div v-for="(pergunta, j) in linha.pergunta" :key="j">
                                <div :class="j == 4 ? 'html2pdf__page-break add-margim-top': '' ">
                                      <pergunta-responder
                                          :perguntaResponder="pergunta"
                                          :secao="linha"
                                          :salvarForm="salvarForm"
                                          :disabled="false"
                                          :visualizarQuestionario="visualizarQuestionario"
                                          :impressao="true"
                                          @finalizarQuestionario="finalizarQuestionario"
                                          :diretorio="diretorio"
                                      ></pergunta-responder>                                      
                                    </div>
                                </div>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card-body>
        </b-card>
    </b-col>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import perguntaResponder from '@/components/questionarios/ResponderPergunta'
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import SessionStorage from '@/services/session-storage'
import html2pdf from "html2pdf.js";

miniToastr.init()

export default {
  name: 'VisualizarImpressaoQuestionario',
  components: {
    perguntaResponder
  },
  mixins: [validationMixin],
  validations: {
  },
  created () {
    if(!this.$route.params.token){
      let usuario = SessionStorage.get('usuario')

      this.buscaUsuarioIntegracao(usuario)
        
      if (!usuario) {
        this.$router.push('/login')
      }
      this.$store.dispatch('atualizarPermissoes')
    }     
  
    this.$store.dispatch('getQuestionario', this.$route.params.id)
    
  },
  mounted () {
    const agora = new Date()
    this.diretorio = agora.getFullYear().toString() + agora.getMonth().toString() + agora.getDay().toString() + agora.getHours().toString() +
      agora.getMinutes().toString() + agora.getSeconds().toString() + agora.getMilliseconds().toString()
  },
  beforeUpdate () {
    this.getSistema()
  },
  data () {
    return {
      envioRespondido: [],
      questionarioRespondido: [],
      secoesQuestionario: null,
      responsavel: '',
      responsavelCpf: '',
      responsavelOrganizacao: '',
      localizacao: null,
      salvarForm: false,
      usuarioIntegracao: [],
      sistemaIntegracao:[],
      loading: false,
      reenviado: false,
      coordenadas: {lat: '', lon: ''},
      endereco: null,
      diretorio: null
    }
  },
  computed: {
    ...mapState({
      carregando: state => state.resposta.carregando
    }),
    questionario () {
        return this.$store.state.questionario.questionarioEditar
    },
    status () {
      if (!this.$route.matched.some(({ name }) => name === 'Visualizar Resposta')) {
        return this.$store.state.questionario.status
      }
    },
    envio () {
      if (this.$route.matched.some(({ name }) => name === 'Visualizar Resposta')) {
        return this.envioRespondido
      } else {
        return this.$store.state.questionario.envio
      }
    },
    reenvio () {
      return this.reenviado
    },
    sistema () {
      return this.$store.state.sistema.sistemaEditar
    },
    resposta () {
      if (this.$route.matched.some(({ name }) => name === 'Visualizar Resposta')) {
        return this.$store.state.resposta.resposta
      } else {
        return this.$store.state.questionario.respostas
      }
    },
    visualizar () {
      return this.$route.matched.some(({ name }) => name === 'Visualizar Resposta')
    },
    visualizarQuestionario () {
      return this.$route.matched.some(({ name }) => name === 'Visualizar Formulário')
    },
    visualizarResposta () {
      return this.$route.params.external !== undefined
    },
    isValid () {
      return !this.$v.$anyError
    }
  },
  watch: {
    'status': function () {
      if (!this.visualizar) {
        if (this.status === 'respondido') {
          this.$store.dispatch('setMensagemQuestionario', 'Você já respondeu este formulário!', 'respondido')
          this.$router.push('/mensagem')
        }

        if (this.status === 'suspenso') {
          this.$store.dispatch('setMensagemQuestionario', 'Este formulário não está mais disponível para preenchimento!', 'suspenso')
          this.$router.push('/mensagem')
        }

        if (this.status === 'reenviado') {
          this.reenviado = true
        }

        this.setDados()
      }
    },
    'resposta': function () {
      if (this.$route.matched.some(({ name }) => name === 'Visualizar Resposta')) {
        this.questionarioRespondido = this.resposta.envio.questionario
        this.envioRespondido = this.resposta.envio
        this.setDados()
      }
    },
    'questionario': function () {
      if (this.$route.matched.some(({ name }) => name === 'Visualizar Formulário')) {
        this.setDados()
      }
    },
  },
  methods: {
    generateReport () {   
        window.scrollTo(0,0)
        
          html2pdf(this.$refs.document, {
               margin:       [0, -0.50, -0.40, -0.40], 
               filename:     this.questionario.titulo + '.pdf',
               image:        { type: 'jpeg', quality: 0.98 },
               html2canvas:  { dpi: 192, scale: 2, letterRendering: true},
               jsPDF:        { unit: "in", format: "a4", orientation: "portrait"},
               pagebreak:    {avoid: 'tr'},
              // pageBreak: { mode: 'legacy'},
              //  pagebreak: { mode: 'css', after: '.before' },
               compressPDF: true
         }).then((result) => {
            setTimeout(() =>  window.close() , 1000)
        })        
    },
    getSistema () {
      if (this.questionario.sistema_cliente_id !== undefined && this.sistema.length < 1) {
        this.$store.dispatch('getSistema', this.questionario.sistema_cliente_id).then((result) => {
          setTimeout(() => this.generateReport() , 1000)     
        })
      }
    },
    setDados () {
      let secoes = []

      if (this.visualizar || this.reenviado) {
        this.responsavel = this.resposta.nome_responsavel
        this.responsavelCpf = this.resposta.cpf_responsavel
        this.responsavelOrganizacao = this.resposta.nome_organizacao
        this.localizacao = !this.resposta.endereco && !this.resposta.lat && !this.resposta.lon ? 'nao_aceito' : 'aceito'
        this.coordenadas.lat = this.resposta.lat
        this.coordenadas.lon = this.resposta.lon
      }

      if (this.questionario.secoes) {
        this.questionario.secoes.forEach((element) => {
          // cria a secao
          secoes.push({
            titulo: element.titulo,
            ordem: element.ordem,
            pergunta: []
          })

          let numero = 0

          // percorre as perguntas da seção
          element.pergunta.forEach((element) => {
            numero += 1
            // chama o metodo que seta as perguntas e retroativamente suas opções e dependentes
            this.setPergunta(element, secoes[(secoes.length - 1)].pergunta, numero)
          })
        })
      }

      this.secoesQuestionario = secoes
    },
    setPergunta (pergunta, array, numero, dependente = false, posicaoPai = null, numeroPai = '', opcaoDependente = null) {
      let posicao = 0

      //  prepara as variaveis para receberem respostas
      let respostaOpRespondida = null
      let respostaTextoRespondida = null
      let respostaUploadRespondida = []
      let exibe = !dependente

      //  se for visualização de resposta ou reenvio do questionario seta as respostas
      if (this.visualizar || this.reenviado) {
        this.resposta.perguntas_respostas.forEach((element) => {
          if (pergunta.id === element.pergunta_id) {
            if (element.alternativa_id !== null) {
              respostaOpRespondida = element.alternativa_id
            }

            if (element.alternativas_respondidas.length > 0) {
              respostaOpRespondida = []
              element.alternativas_respondidas.forEach((item) => {
                respostaOpRespondida.push(item.alternativa_id)
              })
            }

            if (element.arquivos.length > 0) {
              element.arquivos.forEach(file => {
                respostaUploadRespondida.push({
                  nome: file.resposta_upload.substring(file.resposta_upload.indexOf('documentos/') + 11),
                  data: file.resposta_upload
                })
              })
            }

            respostaTextoRespondida = element.resposta_texto
            exibe = true
          }
        })
      }

      //  se for visualização do formulário em si libera a exibição de todas as perguntas
      if (this.visualizarQuestionario) {
        exibe = true
      }

      //  seta os dados para o array das perguntas
      let numeroAtual = dependente ? numeroPai + '.' + numero : numero
      array.push({
        numero: numeroAtual,
        id: pergunta.id,
        titulo: pergunta.titulo,
        ordem: pergunta.ordem,
        hint: pergunta.hint,
        tipo: pergunta.tipo,
        size: pergunta.size,
        dependente: dependente,
        posicaoPai: posicaoPai,
        opcaoDependente: opcaoDependente,
        exibe: exibe,
        required: pergunta.required,
        finaliza_questionario: pergunta.finaliza_questionario,
        opcoes: [],
        resposta: {
          respostaOp: respostaOpRespondida,
          respostaTexto: respostaTextoRespondida,
          perguntaId: pergunta.id,
          respostaUpload: respostaUploadRespondida
        }
      })

      //  posição do registro inserido
      posicao = array.length - 1

      //  numero de posição da pergunta dependente
      let numeroDependente = 0

      //  percorre as opções e seta as mesmas, verifica se tem dependente e repete este processo
      pergunta.opcoes_perguntas_dependentes.forEach((opcaoDependente) => {
        array[posicao].opcoes.push({
          id: opcaoDependente.id,
          resposta: opcaoDependente.resposta,
          possuiDependente: opcaoDependente.perguntas_dependentes.length > 0,
          finaliza_questionario: opcaoDependente.finaliza_questionario
        })

        opcaoDependente.perguntas_dependentes.forEach((perguntaDependente) => {
          numeroDependente += 1
          this.setPergunta(perguntaDependente, array, numeroDependente, true, posicao, numeroAtual, opcaoDependente.id)
        })
      })

      //  por conta de possuir dependentes da propria pergunta percorre os mesmos e repete este processo
      pergunta.perguntas_dependentes.forEach((perguntaDependente) => {
        numeroDependente += 1
        this.setPergunta(perguntaDependente, array, numeroDependente, true, posicao, numeroAtual)
      })
    },
    finalizarQuestionario (value) {
      let final = false
      let secoes = []

      this.secoesQuestionario.every(function (element, index) {
        let perguntas = []

        element.pergunta.every(function (item, index) {
          perguntas.push(item)

          if (item.id === value) {
            final = true
          }
          if (final) return false
          else return true
        })

        secoes.push({
          titulo: element.titulo,
          ordem: element.ordem,
          pergunta: perguntas
        })

        if (final) return false
        else return true
      })

      this.secoesQuestionario = secoes
    },
    buscaUsuarioIntegracao(user_id){
      Vue.http.get('api/usuario/' + user_id).then(response => {      
        this.usuarioIntegracao = response.data.data[0]
        if(this.usuarioIntegracao.sistema_cliente_id){
            Vue.http.get('api/sistema/' + this.usuarioIntegracao.sistema_cliente_id).then(response => {
              this.sistemaIntegracao = response.data.data[0]             
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.sistema-nome {
    text-align: right;
}

.secao-head {
  background-color: lightgrey;
  font-weight: bold;
  font-size: 14px;
}

#map {
  height: 500px;
  width: 100%;
}

.titulo {
    text-align: center;
}
</style>
<style>
.form-control {
  border: 0.5px solid #272d31;
}

.form-group {
  margin-bottom: 0rem;
}

.add-margim-top{
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 0rem;
}

.card {
  border: 0px;
}

.card-header-form {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
    max-height: 55px;
}
</style>

<style>
.editor {
    width: 100%;
    height: 80%;
}

.bold {
    font-weight: bold;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>



// WEBPACK FOOTER //
// src/pages/site/externa/VisualizarImpressaoQuestionario.vue